enum RegistrationPersonalAboutYouActionType {
    REGISTRATION_PERSONAL_ABOUT_YOU_REQUEST_DATA = "REGISTRATION_PERSONAL_ABOUT_YOU_REQUEST_DATA",
    REGISTRATION_PERSONAL_ABOUT_YOU_DISPLAY_ERROR = "REGISTRATION_PERSONAL_ABOUT_YOU_DISPLAY_ERROR",
    REGISTRATION_PERSONAL_ABOUT_YOU_HIDE_SPINNER = "REGISTRATION_PERSONAL_ABOUT_YOU_HIDE_SPINNER",
}

export default RegistrationPersonalAboutYouActionType;